import { AppAreaConfig } from '@/funnels/@types'

// DEV-35942: a separate landing for US-themed creatives (flag, patriotic cues) on /app-usa.
// The Builder funnel and its slug are glp-app's, so CRM and analytics see the same funnel — the
// variant shows in the landing id (`LANDING_glp-usa-*` on OnboardingStepShow) and the creative's
// utm. The paywall is its own route (`/plan/glp-usa`) with a one-to-one copy of glp-app's config:
// the funnels' paywalls will drift apart, and a shared route would also let the later area win
// `resolveAppAreaByPaywallRoute`, sending glp-app's CRM links into this area.
const appAreaConfig: AppAreaConfig = {
	appArea: 'glp-usa',
	options: {
		userTags: ['glp'],
		medicationFromLanding: true,
	},
	landing: {
		// The creative's `utm_term` picks the variant as on /app (DEV-35776): A1 → tirzepatide,
		// B1 → semaglutide, neither → universal. `medication` pre-picks the paywall the same way.
		// Tirzepatide first, so a term with both letters gets the same compound as on /app.
		ids: ['glp-usa-universal'],
		overrides: [
			{ ids: ['glp-usa-tirzepatide'], matcher: { utm_term: /a1/i }, medication: 'tirzepatide' },
			{ ids: ['glp-usa-semaglutide'], matcher: { utm_term: /b1/i }, medication: 'semaglutide' },
		],
		route: {
			path: '/app-usa',
			name: 'glp-usa-funnel',
		},
	},
	funnel: {
		id: 'ob-kova-glp-1-app-ds',
		route: {
			path: '/app-usa/ob/:page(.*)?',
			name: 'glp-usa',
		},
		slug: 'glp-app',
		locale: ['en'],
	},
	paywall: {
		routeName: 'plan-glp-usa',
	},
}

export default appAreaConfig
